"use client";

import React, { useCallback, useEffect, useState } from "react";
import { P, Span, Title } from "@motorata/base-ui.components.atoms.typography";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { Pagination } from "@motorata/base-ui.components.molecules.pagination";
import styled from "styled-components";
import { usePathname, useRouter } from "next/navigation";
import OfferBlock from "../../components/shared/OfferBlock";
import { GET } from "@/services/GET";
import { convertPage } from "@/helpers/pagination.helper";
import LoaderBlock from "@/components/shared/LoaderBlock";

const ProfileContentOffers = ({ slug, brand, model, page }: {
  slug: any
  brand: any
  model: any
  page: any
}) => {
  const router = useRouter();
  const pathname = usePathname();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const handleChangeCurrentPage = useCallback(
    (page: number) => {
      router.push(`${pathname}?p=${page}`);
    },
    []
  );

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true)
        const data = await GET.getProfileOffers(slug, brand, model, convertPage(page));
        setData(data)
      }finally {
        setLoading(false)
      }
    }

    fetch()
  }, [slug, brand, model, page])

  if(loading)
    return <LoadingWrapper>
      <LoaderBlock height="60px" />
      <LoaderBlock height="200px" />
      <LoaderBlock height="200px" />
      <LoaderBlock height="200px" />
    </LoadingWrapper>

  return (
    <Wrapper>
      <Box marginBottom="M">
        <Title type="secondary" styleType="primary" margin="0">
          Wszystkie ogłoszenia
        </Title>
        <P color="third" margin="0">
          Znależliśmy dla Ciebie <Span fontWeight="bold"> {data?.totalElements} </Span>
          ofert
        </P>
      </Box>
      <OffersContainer>
        {data?.content.map(offer => (
          <OfferBlock
            key={offer.id}
            offer={offer}
          />
        ))}
        {!!data?.totalPages && (
          <Pagination
            defaultPage={data.pageable.pageNumber + 1}
            totalPages={data?.totalPages}
            onChange={(number) => handleChangeCurrentPage(number)}
          />
        )}
      </OffersContainer>
    </Wrapper>
  );
};

export default ProfileContentOffers;

const LoadingWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  grid-template-columns: 1fr;
  grid-gap: ${({ theme }) => theme.space.S};
`

const OffersContainer = styled(Box)`
  > div {
    margin-bottom: ${({ theme }) => theme.space.S}
  }
`;

const Wrapper = styled(Box)`
  @media (max-width: 1200px) {
    margin-top: 2rem;
  }
`;
